import { useEffect, useState, useCallback } from 'react';
import ResizeObserver from 'resize-observer-polyfill';

export function useEffectPostMsgHeight(formContent, progressBar, isActive) {
    useEffect(() => {
        if (isActive && formContent) {
            const ro = new ResizeObserver(entries => {
                for (const entry of entries) {
                    if (entry.target === formContent) {
                        const formHeight = formContent.clientHeight;
                        const progressBarHeight = progressBar ? progressBar.clientHeight : 0;
                        // 480 為 google recaptcha 的高度，目前沒辦法拿到 recaptcha 的 dom node
                        // 因此 form body 不能低於 480px
                        window.parent.postMessage(
                            { height: Math.max(formHeight + progressBarHeight, 480) },
                            '*'
                        );
                    }
                }
            });
            ro.observe(formContent);
            return () => {
                ro.unobserve();
            };
        }
    }, [formContent, progressBar, isActive]);
}

export function useListenPostMessage(callBack) {
    useEffect(() => {
        window.addEventListener('message', callBack, false);
        return () => {
            window.removeEventListener('message', callBack, false);
        };
    }, [callBack]);
}

export function useEmbededPostMsgInfo() {
    const [trackField, setTrackField] = useState({});
    const [promoLoginToken, setToken] = useState();
    const [serialNo, setSerialNo] = useState();
    const [isSuspendPostFormMode, setIsSuspendPostFormMode] = useState(false);
    const handleMessage = useCallback(event => {
        const {
            data: { utmData, authToken, serialNumber, suspendPostForm }
        } = event;
        if (utmData) {
            setTrackField({ ...utmData });
        }
        if (authToken) {
            setToken(authToken);
        }
        if (serialNumber) {
            setSerialNo(serialNumber);
        }
        if (suspendPostForm) {
            setIsSuspendPostFormMode(true);
        }
    }, []);
    useListenPostMessage(handleMessage);
    return { trackField, promoLoginToken, serialNo, isSuspendPostFormMode };
}
